<template>
  <v-container fluid>
    <v-alert
      class="ma-0"
      type="error"
      :value="true"
      dense
      tile
      single-line
      text
      transition="slide-y-transition"
    >
      Route [{{invalidRouteText}}] not found.  Please check your link.
    </v-alert>
  </v-container>
</template>
<script>
export default {
  name: 'NotFound',
  props: ['invalidroute'],
  data() {
    return {
      invalidRouteText: ''
    }
  },
  mounted() {
    if(this.$route.query && this.$route.query.invalidroute) {
      this.invalidRouteText = this.$route.query.invalidroute
    }
  }
}
</script>